import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * PrivateRoute - A reusable wrapper for route protection based on authentication and role.
 *
 * @param {boolean} isAuthenticated - Whether the user is logged in.
 * @param {string[]} allowedRoles - Array of roles that are allowed to access this route.
 * @param {string} userRole - Current user's role from custom claims.
 * @param {JSX.Element} children - The component to render if allowed.
 */
function PrivateRoute({ isAuthenticated, allowedRoles, userRole, children }) {
  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to="/" />;
  }

  return children;
}

export default PrivateRoute;
